type LineItem = { amountCents: number };

type CalculateCostsArgs = {
  recurringPriceCents?: number;
  lineItems?: LineItem[];
  tipPercent?: number;
};

type CalculateCostsResult = {
  oneTimeCost: number;
  recurringCost: number;
  tipAmountCents: number;
  oneTimeTotalCost: number;
};

export const calculateCosts = ({
  recurringPriceCents = 0,
  lineItems = [],
  tipPercent = 0,
}: CalculateCostsArgs = {}): CalculateCostsResult => {
  const oneTimeCost = lineItems.reduce(
    (sum, item) => sum + item.amountCents,
    0
  );
  const recurringCost = recurringPriceCents;
  const tipAmountCents = Math.round(
    (recurringCost + oneTimeCost) * (tipPercent / 100)
  );
  return {
    oneTimeCost,
    recurringCost,
    tipAmountCents,
    oneTimeTotalCost: recurringCost + oneTimeCost + tipAmountCents,
  };
};
